<div class="modal fade contact_etoro" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel"><i class="fa fa-envelope-o" aria-hidden="true"></i>
            Contact Us</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form action="contact_email.php" method="post" onsubmit="return contactValidation();"> 
            <div class="form-group">
              <label for="contact_name" class="col-form-label">Name</label>
              <input type="text" class="form-control" name="contactName" id="contactName" placeholder="Your Name">
            </div>
            <div class="form-group">
              <label for="contactEmail" class="col-form-label">Email</label>
              <input type="email" class="form-control" name="contactEmail" id="contactEmail" placeholder="example@gmail.com">
            </div>
            <div class="form-group">
              <label for="contact_message" class="col-form-label">Message <i class="fa fa-info-circle" aria-hidden="true"></i></label>
              <textarea class="form-control" name="contactMsg" id="contact_message" rows="4" placeholder="Write your message"></textarea>
            </div>
            <div class="form-group">
              <button type="submit" name="contactSubmit" class="btn btn-primary form-control"><i class="fa fa-paper-plane-o" aria-hidden="true"></i>
              Send Message
              </button>
              <small>Our representative will get back to you as soon as possible</small>
            </div>
         </form>
        </div>
      </div>
    </div>
  </div>
